<template>
  <InvoiceTransmissionHeader>
    <ClientDictionaryTable/>
  </InvoiceTransmissionHeader>
</template>
<script>

import ClientDictionaryTable from "@/invoice-transmission/components/tables/ClientDictionaryTable.vue";
import InvoiceTransmissionHeader from "@/invoice-transmission/components/InvoiceTransmissionHeader.vue";

export default {
  name: 'FactureXClientView',
  components: {ClientDictionaryTable, InvoiceTransmissionHeader}
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color THEME_COLOR_PRIMARY

  span
    color THEME_COLOR_PRIMARY_FADDED
</style>
